import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
let HomepageService = class HomepageService {
    constructor(homepageApi) {
        this.homepageApi = homepageApi;
    }
    async saveProductUpdatesInfo(params) {
        try {
            const data = await this.homepageApi.setProductUpdates(params);
            return data.status;
        }
        catch (err) {
            return false;
        }
    }
    async getUploadImagePath(base64) {
        const data = await this.homepageApi.uploadImage(base64);
        return data.status ? data.data : false;
    }
    async saveAdvertInfo(params) {
        try {
            const data = await this.homepageApi.setAdImageData(params);
            return data.status;
        }
        catch (err) {
            return false;
        }
    }
};
HomepageService = __decorate([
    injectable(),
    __param(0, inject(Symbols.HomepageApi)),
    __metadata("design:paramtypes", [Object])
], HomepageService);
export { HomepageService };
